// extracted by mini-css-extract-plugin
module.exports = {"search":"hospital-sponsorship_search___K8z9"};